import { Skeleton, useIsMobileOrTablet } from '@epilot/concorde-elements'
import classNames from 'classnames'

import classes from '../../../Skeleton.module.scss'

export const MultipleChoiceButtonSkeleton = ({
  options
}: {
  options: string[][]
}) => {
  const isMobileOrTablet = useIsMobileOrTablet()

  return (
    <div className={classes.root}>
      {/* Mimics buttons */}
      <div
        className={classNames(
          isMobileOrTablet || options.length > 4
            ? classes.buttonWrapColumn
            : classes.buttonWrapRow
        )}
      >
        {options.map((_option: string[], index: number) => (
          <Skeleton className={classes.button} key={index}>
            &nbsp;
          </Skeleton>
        ))}
      </div>
    </div>
  )
}
